import * as React from "react";
import { WooCommerceCartBlock } from "@/integrations/wordpress/WooCommerceCartBlock";
export default function YourSelection() {
  return <section id="your-selection" className="bg-background text-foreground py-16 md:py-24 relative">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03] dark:opacity-[0.05]" style={{
      backgroundImage: 'radial-gradient(circle at 2px 2px, currentColor 1px, transparent 0)',
      backgroundSize: '32px 32px'
    }} aria-hidden="true" />

      <div className="container mx-auto px-4 max-w-6xl relative z-10">
        <div className="mb-12 border-b-2 border-primary pb-6 flex flex-col md:flex-row md:items-end justify-between gap-4">
          <div>
            <h2 className="text-4xl md:text-5xl font-default font-bold uppercase tracking-tighter text-foreground">
              Extraction Manifest
            </h2>
            <p className="text-muted-foreground mt-3 font-mono text-sm uppercase tracking-widest">
              Review your survival assets before finalizing coordinates.
            </p>
          </div>
          <div className="text-right hidden md:block">
            <span className="inline-block bg-primary text-primary-foreground text-xs font-mono px-2 py-1 font-bold tracking-widest uppercase">
              Secure Connection
            </span>
          </div>
        </div>

        {}
        <div className="bg-card text-card-foreground border border-border shadow-2xl p-1 md:p-8 rounded-none relative">
          {}
          <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-primary pointer-events-none" aria-hidden="true" />
          <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-primary pointer-events-none" aria-hidden="true" />
          <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-primary pointer-events-none" aria-hidden="true" />
          <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-primary pointer-events-none" aria-hidden="true" />
          
          <div className="min-h-[400px]">
            <WooCommerceCartBlock />
          </div>
        </div>
      </div>
    </section>;
}